import Axios from 'axios'

export async function getShippingFedex(cubagens, dataEnterprise, resumoPedido, totalCaixas, isAgrupped, proximaCaixa) {
  if (cubagens?.length !== 0) {
    try {
      const cubagem = []

      cubagens?.map((item, index) => {
        const { cubagensCargoBR } = item

        cubagem.push({
          index: index,

          total: cubagensCargoBR.amount * cubagensCargoBR.height * cubagensCargoBR.length * cubagensCargoBR.width * 200,
        })
      })

      const reducerCubagem = cubagem?.reduce((acc, item) => {
        const { total } = item

        return acc + total
      }, 0)

      const reducerCubagemPesoTotal = cubagens?.reduce((acc, item) => {
        const { peso_total } = item

        return acc + peso_total
      }, 0)

      const selectCubagem = reducerCubagemPesoTotal > reducerCubagem ? reducerCubagemPesoTotal : reducerCubagem

      console.log('teste', {
        cubagem,
        reducerCubagem,
        reducerCubagemPesoTotal,
        selectCubagem,
      })

      const cubagensKangu = cubagens?.map((item) => {
        const { cubagensCargoBR } = item

        return {
          altura: isNaN(parseFloat(cubagensCargoBR.height)) ? 0 : parseFloat(cubagensCargoBR.height),
          comprimento: isNaN(parseFloat(cubagensCargoBR.length)) ? 0 : parseFloat(cubagensCargoBR.length),
          largura: isNaN(parseFloat(cubagensCargoBR.width)) ? 0 : parseFloat(cubagensCargoBR.width),
          quantidade_caixas: isNaN(parseInt(item.quantidade_caixas)) ? 0 : parseInt(item.quantidade_caixas),
          valor_total: isNaN(parseFloat(item.valor_total)) ? 0 : parseFloat(item.valor_total),
          pesoCaixa: isNaN(parseFloat(item.peso_caixa)) ? 0 : parseFloat(item.peso_caixa),
        }
      })

      const valorTotalItem = resumoPedido?.vlrTotal

      const pesoTotalItens = cubagens?.reduce((acc, item) => {
        const peso = isNaN(parseFloat(item.peso_caixa)) ? 0 : parseFloat(item.peso_caixa)
        const quantidade = isNaN(parseInt(item.quantidade_caixas)) ? 0 : parseInt(item.quantidade_caixas)
        return acc + peso * quantidade
      }, 0)

      console.log('pesoTotalItens', pesoTotalItens, {
        cubagens,
        resumoPedido,
      })

      const unformattedNumbersCpfCnpj = dataEnterprise?.ent_cpf_cnpj?.replace(/[^0-9]/g, '')

      const params = {
        cubagem: cubagensKangu,
        cpf_cnpj_cliente: unformattedNumbersCpfCnpj,
        cep_cliente: dataEnterprise?.ent_cep,
        valor_total_itens: valorTotalItem,
        peso_total_itens: pesoTotalItens,
        inscricao_estadual: dataEnterprise?.inscricao_estadual,
      }

      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/simula-fedex/simulacao-fedex', params)

      console.log('responseTNT', {
        response: response.data,
        params: params,
      })

      const dataFormatted = {
        ...response.data,
        erro: response.data.Tranportadora,
        Municipio_Destino: response.data.Municipio_Destino,
        Valor_Total: parseFloat(response.data.Valor_Total),
        Prazo: parseInt(response.data.Prazo),
        vlrImposto: parseFloat(response.data.vlImposto),
        paletizacao: response.data.paletizacao,
        gris: response.data.gris,
        Agendamento_entrega: response.data.Agendamento_entrega,
        tde: response.data.tde,
        nome: 'TNT',
        nome_transp: 'TNT',
        isFedex: true,
        id: new Date().getTime(),
        prazo: {
          min: response.data.Prazo,
          max: parseInt(response.data.Prazo) + 1,
        },
        //colocar + 10% no valor total
        preco: parseFloat(response?.data.Valor_Total + response?.data.Valor_Taxa) * 1.1, // valor total + 10% da taxa
        numero_nota: dataEnterprise?.numero_nota,
        tipo_transportadora: 'F',
        valor_simulacao: parseFloat(response?.data.Valor_Total + response?.data.Valor_Taxa) * 1.1, // valor total + 10% da taxa
        data_prevista: response.data.Prazo
          ? new Date(new Date().getTime() + response.data.Prazo * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
          : 'Sem data prevista', //2021-09-09

        quantidade_caixas: totalCaixas,
        valida_frete: dataEnterprise.valida_frete,
        originalValue: parseFloat(response?.data.Valor_Total),
      }

      //transformar em array
      let arrayShipping = []

      if (response.data.Transportadora) {
        arrayShipping.push(response.data)
        return arrayShipping
      }

      arrayShipping.push(dataFormatted)

      console.log(dataFormatted, 'arrayShipping')

      return arrayShipping
    } catch (error) {
      console.log('error', error)
    }
  }
}
